// extracted by mini-css-extract-plugin
module.exports = {"select":"HeadCoach_select__24UNO","empty":"HeadCoach_empty__1q9s3"};